module.exports = __webpack_public_path__ + "img/logo-ace-form.ed8d56fa.png";